









module.exports =
  name: 'compare_periods'
  metaInfo: -> { title: "#{@$t('By Months')} - #{@$t('Reports')}" }
  computed:
    default_ranges: -> ['last_3_months', hm_date.format(new Date, 'YYYY')]
  components:
    period: require('./period.vue').default
